import React from "react";
import HomeOutlinedIcon from "@material-ui/icons/HomeOutlined";
import PermIdentityOutlinedIcon from "@material-ui/icons/PermIdentityOutlined";
import PeopleAltOutlinedIcon from "@material-ui/icons/PeopleAltOutlined";
import SettingsOutlinedIcon from "@material-ui/icons/SettingsOutlined";
import CheckCircleOutlineIcon from "@material-ui/icons/CheckCircleOutline";
import AccessTimeOutlinedIcon from "@material-ui/icons/AccessTimeOutlined";
import FormatListBulletedOutlined from "@material-ui/icons/FormatListBulletedOutlined";
import { FbSidebarItem } from "@flexibees/core";
import { Link, useRouteMatch } from "react-router-dom";
import ListOutlinedIcon from "@material-ui/icons/ListOutlined";
import { useDispatch } from "react-redux";
import * as candidateAction from "../actions/candidateAction";

const menuItems = [
  {
    name: "Dashboard",
    icon: HomeOutlinedIcon,
    path: "/dashboard",
  },
  {
    name: "User Management",
    icon: PermIdentityOutlinedIcon,
    path: "/user",
  },
  {
    name: "All Candidates",
    icon: PeopleAltOutlinedIcon,
    path: "/candidate",
  },
  { name: "All Jobs", icon: ListOutlinedIcon, path: "/jobs" },
  {
    name: "Project Launches",
    icon: ListOutlinedIcon,
    path: "/project-launches",
  },
  { name: "MP Launches", icon: ListOutlinedIcon, path: "/mp-launches" },
  {
    name: "Pricing",
    icon: CheckCircleOutlineIcon,
    path: "/pricing",
  },
  {
    name: "Configuration",
    icon: SettingsOutlinedIcon,
    path: "/configuration",
  },
  {
    name: "Confirmation",
    icon: CheckCircleOutlineIcon,
    path: "/confirmation",
  },
  {
    name: "Availability",
    icon: AccessTimeOutlinedIcon,
    path: "/availability",
  },
  {
    name: "Attributes",
    icon: FormatListBulletedOutlined,
    path: "/attributes",
  },
  {
    name: "SSO Configuration",
    icon: SettingsOutlinedIcon,
    path: "/sso-configuration",
  },
];

export default function MenuItems() {
  const dispatch = useDispatch()
  const [activeMenuIndex, setactiveMenuIndex] = React.useState(
    menuItems.findIndex((mItem) => window.location.href.includes(mItem.path)),
  );
  const [activeMenu, setActiveMenu] = React.useState(
    activeMenuIndex < 0 ? "" : menuItems[activeMenuIndex].name,
  );

  React.useEffect(() => {
    setactiveMenuIndex(
      menuItems.findIndex((mItem) => window.location.href.includes(mItem.path)),
    );
  }, [window.location.href]);

  React.useEffect(() => {
    setActiveMenu(activeMenuIndex < 0 ? "" : menuItems[activeMenuIndex].name);
  }, [activeMenuIndex]);

  const changeActiveMenu = (menu) => {
    if(menu === "Pricing"){
      dispatch(candidateAction.resetPricingListHours())
    }
    setActiveMenu(menu);
  };

  const { path } = useRouteMatch();

  return (
    <div>
      {menuItems.map((item, index) => {
        return (
          <Link
            to={`${path}${item.path}`}
            style={{ textDecoration: "none" }}
            key={item.name}
          >
            <FbSidebarItem
              name={item.name}
              icon={item.icon}
              key={item.name}
              activeMenu={activeMenu}
              changeActiveMenu={changeActiveMenu}
            />
          </Link>
        );
      })}
    </div>
  );
}
